import { createSelector } from 'reselect';

export const getSearchAgentResults = createSelector(({ agent }) => agent.agentSearchResults, results => results);

export const getAgentSelected = ({ agent }) => agent.agentSelected;

export const selectAgentPhotos = ({ agent }) => agent.agentPhotos;

export const selectAgentPreferredPhoto = ({ agent }) => agent.singleAgentPhoto;

export const selectAgentPreferredPhotoDetails = createSelector(selectAgentPhotos, photos => {
  let preferredPhoto = {};
  if (photos?.length > 0) {
    [preferredPhoto] = photos;
    photos?.map(singlePhoto => {
      if (singlePhoto.PreferredPhotoYN) preferredPhoto = singlePhoto;
      return null;
    });
  }
  return preferredPhoto;
});
